import * as React from "react";
import Drawer from "@mui/material/Drawer";
import { useEffect, useState } from "react";
import { toggleDrawer } from "../../utils/utils";
import NewButton from "../common/NewButton/NewButton";
import { CloseOutlined } from "@mui/icons-material";
import {
  Stack,
  Box,
  Typography,
  IconButton,
  FormControlLabel,
  FormGroup,
  Switch,
  alpha,
  styled,
} from "@mui/material";
import { primary } from "../../theme/palette";
import NewPartnership from "./NewPartnership";
import { PartnershipType } from "../../types/genericType";
import { useDispatch } from "react-redux";
import { resetSelectedPartnership } from "../../redux/features/partnershipsSlice";
import CustomSnackbar from "../common/Snackbar/CustomSnackbar";

const ColoredSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: primary,
    "&:hover": {
      backgroundColor: alpha("##606ADD", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: primary,
  },
}));

type NewPartnershipDrawerPropType = {
  getPartnershipsData: Function;
  partnershipsData: PartnershipType[];
  setPartnershipsData: Function;
  openEditDrawer: boolean;
  selectedPartnership: PartnershipType;
  setOpenEditDrawer: Function;
  setSelectedPartnership: Function;
  onDetailsPage?: boolean;
};

const NewPartnershipDrawer = (props: NewPartnershipDrawerPropType) => {
  const {
    getPartnershipsData,
    openEditDrawer,
    selectedPartnership,
    setOpenEditDrawer,
    onDetailsPage,
  } = props;

  const initialActiveState = selectedPartnership?.id
    ? selectedPartnership.isActive
    : true;

  const [open, setOpen] = useState(false);
  const [editFlow, setEditFlow] = useState(false);
  const [active, setActive] = useState(initialActiveState);
  const [onSuccess, setOnSuccess] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");

  useEffect(() => {
    if (selectedPartnership?.id) {
      setActive(selectedPartnership.isActive);
    } else {
      setActive(true);
    }
  }, [selectedPartnership]);

  const dispatch = useDispatch();

  const handleDrawerClose = () => {
    setOpen(false);
    setOpenEditDrawer(false);
    setEditFlow(false);
    setActive(true);
  };

  useEffect(() => {
    if (openEditDrawer) {
      setEditFlow(true);
      setOpen(openEditDrawer);
    }
  }, [openEditDrawer]);

  const handleDrawerOpen = toggleDrawer<React.KeyboardEvent | React.MouseEvent>(
    true,
    setOpen
  );

  useEffect(() => {
    if (!editFlow && !onDetailsPage) {
      dispatch(resetSelectedPartnership());
      setActive(true);
    }
  }, [editFlow]);

  const drawerComp = (
    <Stack>
      <Box className="drawer-header" role="presentation">
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          fontWeight={700}
        >
          {editFlow ? "Edit Partnership" : "New Partnership"}
        </Typography>
        <FormGroup>
          <FormControlLabel
            control={
              <ColoredSwitch
                checked={active}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setActive(event.target.checked);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label={active ? "Active" : "Inactive"}
          />
        </FormGroup>
        <IconButton
          aria-label="toggle password visibility"
          onClick={handleDrawerClose}
          size="large"
        >
          <CloseOutlined />
        </IconButton>
      </Box>
      <NewPartnership
        getPartnershipsData={getPartnershipsData}
        handleDrawerClose={handleDrawerClose}
        isActive={active}
        editFlow={editFlow}
        setOnTxnSuccess={setOnSuccess}
        setSnackbarMsg={setSnackbarMsg}
      />
    </Stack>
  );

  return (
    <div className="transaction-drawer">
      <React.Fragment>
        {!onDetailsPage && (
          <NewButton
            handleBtnClick={handleDrawerOpen}
            title="NEW PARTNERSHIP"
            type="contained"
          />
        )}
        <Drawer
          anchor="right"
          variant="temporary"
          onClose={handleDrawerClose}
          open={open}
          sx={{
            display: { xs: "none", sm: "block" },
            "&.MuiDrawer-root .MuiDrawer-paper": {
              marginTop: "65px",
              width: "436px",
            },
          }}
        >
          {drawerComp}
        </Drawer>
        <CustomSnackbar
          open={onSuccess}
          message={snackbarMsg}
          setOpen={setOnSuccess}
        />
      </React.Fragment>
    </div>
  );
};

export default NewPartnershipDrawer;
